<template>
  <NavBar
      left-arrow
      @click-left="onClickLeft"
  >
    <template #title>
      <span style="font-size: 18px;font-weight: bold">{{title}}</span>
    </template>
  </NavBar>
  <!--内容区域-->
  <div style="margin-top: 10px">
    <router-view />
  </div>

</template>

<script setup>
import {NavBar} from 'vant';
import {onMounted, ref, watch} from "vue";
import {useRouter} from "vue-router";
import {isMiniProgram} from "@/utils/env";
const router = useRouter();

// 小程序端需要屏蔽「投资」字样（金融类目风险），这里只做标题映射。
// 路由 meta.title 保持原样，因为浏览器端仍在用它。判定逻辑见 src/utils/env.js
const TITLE_MAP_MINI_PROGRAM = {'投资专栏': '支持者专栏'};
const resolveTitle = (t) => (isMiniProgram() && TITLE_MAP_MINI_PROGRAM[t]) || t;

// ⚠️ 必须用 watch 跟随路由：layout 是父级组件，在子路由之间切换时它**不会重新创建**，
//    原先只在 setup 里读一次 currentRoute，会导致切页后标题停留在进入时那一页。
//    （另外首次进入 `/` 时 meta.title 为空 → 导航栏标题空白，配合路由重定向一起修掉。）
const title = ref(resolveTitle(router.currentRoute.value.meta?.title));
watch(
    () => router.currentRoute.value.meta?.title,
    (t) => { title.value = resolveTitle(t); }
);

const onClickLeft = () => history.back();
onMounted(()=>{

})

</script>

<style scoped>
:deep.van-nav-bar {
  background:var(--base-color);
}
:deep .van-nav-bar__title {
  color:white;
}
:deep .van-icon {
  color: white;
}
:deep .van-nav-bar__text {
  color: white;
}
</style>
